import { commonAxios } from '@/plugins/axios'

export const getListAddress = () => commonAxios.get('/v1/common/address')
export const setDefaultAddress = (address_id) =>
  commonAxios.put(`/v1/common/address/update/${address_id}`, { is_default: true })
export const getAddressDetail = (customer_address_id) =>
  commonAxios.get(`/v1/common/address/detail/${customer_address_id}`)
export const updateAddress = (address_id, body) => commonAxios.put(`/v1/common/address/update/${address_id}`, body)
export const newAddress = (body) => commonAxios.post('/v1/common/address/new', body)
export const deleleAddress = (address_id) => commonAxios.delete(`/v1/common/address/delete/${address_id}`)
